import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import { Row } from '../Scaffold';
import ButtonUnstyled from "../../Button/unstyled";

const validate = (values) => {
  const errors = {};
  if (!values.testField) errors.testField = 'Please enter testField';

  return errors;
};

class Page3 extends React.PureComponent {
  componentDidMount() {
    if (window.pageYOffset > this.sectionRef.offsetTop) {
      window.scrollTo({ top: this.sectionRef.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Row classes="page-3" setRef={(sectionRef) => { this.sectionRef = sectionRef; }}>
        <Paragraph classes="images" center>
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/getactive-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/loseweight-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/quitsmoking-roundal.png" alt="" width="100" height="100" />
          <img src="https://livewelldorset.s3.amazonaws.com/Pathways/drink-less.png" alt="" width="100" height="100" />
        </Paragraph>
        <Heading classes="header-text purple" center><span id="register4">YOUR HEALTH AND LIFESTYLE</span></Heading>
        <Paragraph classes="width-limited" center>Thanks for giving us a little information about who you are.</Paragraph>
        <Paragraph classes="width-limited" center>
        We have now reached the health and lifestyle section of the registration. We need to ask some questions about your lifestyle to help us understand how we can help.
        </Paragraph>
        <Paragraph classes="width-limited" center>
          {"We'll"} ask you about your current physical activity levels, height and weight and whether you smoke or drink alcohol. {"We're"} here to help, not to judge, so please be as honest as you can.
        </Paragraph>
        <Paragraph classes="button-groups" center>
          <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
          <ButtonUnstyled classes={['underline-button']} label="Back" onClick={this.props.previousPage} />
        </Paragraph>
      </Row>
    );
  }
}

Page3.propTypes = {
  previousPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(Page3);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Page3.jsx